import { render } from "./GroupingTableHead.vue?vue&type=template&id=1c84da4f"
import script from "./GroupingTableHead.vue?vue&type=script&lang=js"
export * from "./GroupingTableHead.vue?vue&type=script&lang=js"
script.render = render

export default script